module.exports = __webpack_public_path__ + "static/media/bsb.4a749ed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/environment/bsb.png
// module id = 56
// module chunks = 0